import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { Point } from '../../types';
import { fetchReverseGeocode } from '../queries/getReverseGeocode';

export class ReverseLookupLocationResult {
  displayName: string;
}

export function useReverseLookupLocation() {
  const queryClient = useQueryClient();

  const reverseLookupLocation = React.useCallback(
    async (location: Point, resultTypeFilter?: string): Promise<ReverseLookupLocationResult | null> => {
      try {
        return await fetchReverseGeocode(queryClient, location, resultTypeFilter);
      } catch (error) {
        console.error('Error reverse lookup:', error);
      }
      return null;
    },
    [queryClient]
  );

  return { reverseLookupLocation };
}
